/*
 * @Author: zhaoyu zhaoy@normstar.com
 * @Date: 2024-07-18 15:30:49
 * @LastEditors: zhaoyu zhaoy@normstar.com
 * @LastEditTime: 2024-07-18 15:53:22
 * @FilePath: \ns-web-evaluation\pc\src\utils\sm.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { SmCipher } from '@ns/utils'
import storageSettings from '@/settings/storage'
export const sm = new SmCipher()
export const smSelf = new SmCipher({ ...storageSettings.encryptionParams, isAutoFix: false })
